// Projections of a stored SDI/RDI event or form into what the wizard and recaps consume.
import type { ClinicalFormData } from './clinicalWizardConfig';
import type { ClinicalFormFields } from './ClinicalFormStep';
import type { TimelineEvent } from '../types';

export function formDataToFields<T extends ClinicalFormData>(data: T): ClinicalFormFields {
    return {
        date: data.date,
        patientName: data.patientName,
        numberOfAligners: data.numberOfAligners,
        alignerWear: data.alignerWear,
        dmScanFrequency: data.dmScanFrequency,
        alignerChangeFrequency: data.alignerChangeFrequency
    };
}

export function extractVcaNoteFromEvent(event: TimelineEvent): string {
    const payload = event.payload;
    if (!payload || typeof payload !== 'object') return '';
    const raw = payload as Record<string, unknown>;
    return typeof raw.vcaNote === 'string' ? raw.vcaNote : '';
}
